"use client";
import React, { useState, useEffect} from "react";
import ReactModal from "react-modal";
import axios from "axios"
import { useRouter } from "next/navigation";
import { BACKEND_URL } from "@/utils/constants";

import { FaEyeSlash, FaEye} from "react-icons/fa";
const SigninAdmin = ({ signinOpen, setIsSigninOpen }) => {
    const [showPassword,setShowPassword]=useState(false);
 
 useEffect(() => {
        const rootElement = document.getElementById("__next");
        if (rootElement) {
            ReactModal.setAppElement(rootElement);
        }
    }, []);
    const router=useRouter();
    // const {access,setAccess} = useContext(AppContext);
   
    const [formData, setFormData] = useState({
        username: "",
        email: "",
        password: "",
    });

   
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

   
    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("Form Data:", formData);
        
        
        const response = await axios.post(`${BACKEND_URL}/adminsetup/admin/login`, formData,
            {
                withCredentials: true
            }
        );
        console.log(response);

        if(response.data)
        {  
            setIsSigninOpen(false);
            const res = await axios.get(`${BACKEND_URL}/adminsetup/admin/`, {withCredentials:true});
            
            if (typeof window !== "undefined") {
                localStorage.setItem("access", res.data.message);
                localStorage.setItem("expiry",res.data.expiryTimeStamp)
            }
            

                                
            
        router.push("/adminsetup/admin")

        }
    else console.log("login unsucess");
     
      
      
      
        
    };
    useEffect(() => {
  
        function checkAndClearLocalStorage() {
            if (typeof window === "undefined") return; 
            
            const expiryTimestamp:number = localStorage.getItem("expiry");
            if (!expiryTimestamp) return;
    
            const now = Date.now();
            if (now > expiryTimestamp) {
                localStorage.removeItem("access");
                localStorage.removeItem("expiry");
                console.log("LocalStorage cleared as the session expired.");
            } else {
             
                const timeLeft = expiryTimestamp - now;
                setTimeout(checkAndClearLocalStorage, timeLeft);
            }
        }
    
        checkAndClearLocalStorage();
    
        
        const storageListener = (event) => {
            if (event.key === "expiry") {
                checkAndClearLocalStorage();
            }
        };
    
        window.addEventListener("storage", storageListener);
    
        return () => {
            window.removeEventListener("storage", storageListener);
        };
    }, []);

    return (
        <ReactModal
            isOpen={signinOpen}
            onRequestClose={() => setIsSigninOpen(false)}
            ariaHideApp={false}
            className="flex items-center justify-center m-3"
            overlayClassName="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
        >
            <div className="bg-gray-100 rounded-lg flex flex-col sm:flex-row relative max-w-lg w-full p-6 md:p-10 border-2 border-black shadow-lg">
                {/* Close Button */}
                <button
                    className="absolute top-4 right-4 text-gray-600 hover:text-black"
                    onClick={() => setIsSigninOpen(false)}
                >
                    ✕
                </button>

                {/* Form */}
                <div className="w-full bg-gray-50">
                    <h2 className="text-lg font-semibold mb-4 text-black">
                        Sign in as Admin
                    </h2>

                    <form onSubmit={handleSubmit}>
                        {/* Username Field */}
                        <div className="mt-4">
                            <label htmlFor="username" className="block text-sm font-medium text-black">
                                Username
                            </label>
                            <input
                                id="username"
                                name="username"
                                type="text"
                                value={formData.username}
                                onChange={handleChange}
                                className="w-full border rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-[#F9FAFB]"
                                required
                            />
                        </div>

                        {/* Email Field */}
                        <div className="mt-4">
                            <label htmlFor="email" className="block text-sm font-medium text-black">
                                Email
                            </label>
                            <input
                                id="email"
                                name="email"
                                type="email"
                                value={formData.email}
                                onChange={handleChange}
                                className="w-full border rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-[#F9FAFB]"
                                required
                            />
                        </div>
                        <div className="relative mt-4">
            <label htmlFor="password" className="block text-sm font-medium text-black">
                Password
            </label>

            <div className="relative">
                <input
                    id="password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    value={formData.password}
                    onChange={handleChange}
                    className="w-full border rounded px-4 py-2 pr-10 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-[#F9FAFB]"
                    required
                />
                <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                >
                    {showPassword ? <FaEye size={20} /> : <FaEyeSlash size={20} />}
                </button>
            </div>
        </div>

                        {/* Submit Button */}
                        <button
                            type="submit"
                            className="mt-6 w-full bg-gradient-to-r from-blue-500 to-teal-500 text-white font-medium py-2 rounded hover:opacity-90"
                        >
                            Submit
                        </button>
                    </form>
                </div>
            </div>
        </ReactModal>
    );
};

export default SigninAdmin;